import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, MapPin, Clock, Lock } from "lucide-react";
import { Logo } from "./Logo";
import { waLink } from "../config";

export const Footer = () => (
  <footer className="pt-20 pb-10 bg-[#07080c]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-4 gap-10 pb-14 border-b border-slate-800/60">
        <div className="md:col-span-2">
          <a href="#top" className="inline-block group" data-testid="footer-logo">
            <Logo />
          </a>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
            Mais que uma loja de veículos: um ecossistema completo de compra,
            financiamento e gestão. Tecnologia de ERP + CRM a serviço de quem ama carro.
          </p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#top"
                aria-label="Rede social"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 rounded-full glass flex items-center justify-center text-slate-400 hover:text-emerald-400 hover:border-emerald-500/40 transition-colors duration-300"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-5">Navegação</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            {[
              ["Estoque", "#estoque"],
              ["Locação", "#locacao"],
              ["Simulador", "#simulador"],
              ["Plataforma", "#plataforma"],
              ["FAQ", "#faq"],
              ["Contato", "#contato"],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="hover:text-emerald-400 transition-colors duration-300" data-testid={`footer-link-${label.toLowerCase()}`}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-5">Showroom</h4>
          <ul className="space-y-4 text-sm text-slate-400">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />
              Rua Santa Catarina, 122 B — Jardim Milenium<br />Araguari/MG · CEP 38.447-023
            </li>
            <li className="flex gap-3">
              <Clock className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />
              Seg a Sex, 9h às 19h<br />Sáb, 9h às 15h
            </li>
          </ul>
          <a
            href={waLink("Olá! Quero falar com a Seed Motors.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-emerald-400 hover:text-emerald-300 transition-colors"
          >
            WhatsApp direto →
          </a>
        </div>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 text-xs text-slate-500">
        <p>© 2026 Seed Motors. Todos os direitos reservados.</p>
        <p className="flex items-center gap-4">
          <span>CNPJ 00.000.000/0001-00 · Termos · Privacidade</span>
          <Link to="/admin" data-testid="footer-admin-link" className="inline-flex items-center gap-1.5 hover:text-emerald-400 transition-colors">
            <Lock className="w-3 h-3" /> Área do lojista
          </Link>
        </p>
      </div>
    </div>
  </footer>
);
